import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import './Services.css';

function Services() {
  return (
    <div className="services-container">
      <h2 className="title">Our Services</h2>

      <motion.section
        className="service-section"
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        viewport={{ once: true }}
      >
        <h3>Data Mining</h3>
        <p>
          We help businesses extract hidden patterns and insights from vast data sets to make informed decisions.
        </p>
        <ul>
          <li>Predictive analytics & forecasting</li>
          <li>Pattern and trend analysis</li>
          <li>Custom data extraction & cleaning</li>
        </ul>
        {/* <Link to="/services/data-mining" className="learn-more">Learn More</Link> */}
      </motion.section>

      <motion.section
        className="service-section"
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: 0.2 }}
        viewport={{ once: true }}
      >
        <h3>Digital Marketing</h3>
        <p>
          We boost your online presence with proven strategies across social media, search engines, and email campaigns.
        </p>
        <ul>
          <li>SEO & SEM optimization</li>
          <li>Social media campaigns</li>
          <li>Email & content marketing</li>
        </ul>
        {/* <Link to="/services/DigitalMarketing" className="learn-more">Learn More</Link> */}
      </motion.section>

      {/* <motion.section
        className="service-section"
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: 0.4 }}
        viewport={{ once: true }}
      >
        <h3>Cybersecurity</h3>
        <p>
          Protect your digital assets with our comprehensive cybersecurity solutions tailored for modern threats.
        </p>
        <ul>
          <li>Threat monitoring & response</li>
          <li>Security audits & compliance</li>
          <li>Network & endpoint protection</li>
        </ul>
        <Link to="/services/CyberSecurity" className="learn-more">Learn More</Link>
      </motion.section> */}

      <motion.section
  className="service-section"
  initial={{ opacity: 0, y: 30 }}
  whileInView={{ opacity: 1, y: 0 }}
  transition={{ duration: 0.6, delay: 0.6 }}
  viewport={{ once: true }}
>
  <h3>Security Consulting</h3>
  <p>
    Our experts provide strategic guidance to strengthen your security posture, reduce risk, and ensure compliance with the latest standards.
  </p>
  <ul>
    <li>Risk assessment & mitigation</li>
    <li>Security policy & framework development</li>
    <li>Regulatory compliance advisory (ISO, GDPR, etc.)</li>
  </ul>
  {/* <Link to="/services/SecurityConsulting" className="learn-more">Learn More</Link> */}
</motion.section>

    </div>
  );
}

export default Services;
